import { themeAtom } from "../../../shared/atoms";
import { EnvelopeIcon } from "@heroicons/react/24/outline";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

type Props = {
  mailbox: string;
  isLoading: boolean;
  onChangeMailbox: () => void;
};

const AdminKeysSecretsTopBar = ({ mailbox, isLoading, onChangeMailbox }: Props) => {
  const theme = useAtomValue(themeAtom);
  const mailboxLabel = mailbox || "Not configured";

  return (
    <header
      data-test="admin-keys-secrets-top-bar"
      className="relative z-50 flex h-11 flex-none items-center border-b border-gray-200 bg-white px-3 dark:border-gray-700 dark:bg-gray-800"
    >
      <div className="flex min-w-0 flex-1 items-center gap-3 overflow-hidden">
        <h1 className={twMerge("flex-none truncate text-sm font-semibold leading-5", theme.home.tailwind.textDefault)}>
          Keys & Secrets
        </h1>
        <button
          type="button"
          aria-label={`Change Keys & Secrets mailbox. Current mailbox: ${mailboxLabel}.`}
          className="inline-flex h-8 min-w-0 flex-1 items-center gap-1 truncate border border-[#D7E2DE] px-2 py-1 text-left text-[11px] font-semibold text-[#4A5655] transition-colors hover:bg-[#E9F4F3] focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-offset-gray-800 md:max-w-[520px] md:flex-none"
          data-test="admin-keys-secrets-mailbox"
          disabled={isLoading}
          onClick={onChangeMailbox}
          title={mailboxLabel}
        >
          <EnvelopeIcon className="h-3.5 w-3.5 flex-none" />
          <span className="truncate">Mailbox: {mailboxLabel}</span>
        </button>
      </div>
    </header>
  );
};

export default AdminKeysSecretsTopBar;
